import logo from './logo.svg';
import './App.css';
import Statewise from './components/statewisedata/Statewise';

function App() {
  return (
    <>
      <Statewise/>
    </>
  );
}

export default App;
